import React, { FC } from 'react'
import styles from './Tiles.module.scss'
import { TileType } from './types'
import Tile from './Tile'
import useQA from 'hooks/useQA'

type TileListProps = {
  tiles: ReadonlyArray<TileType>
}
const TileList: FC<TileListProps> = ({ tiles }) => {
  const { testId } = useQA()

  return (
    <div className={styles.tileList} {...testId('tiles-list')}>
      {tiles.map((tile, index) => (
        <Tile key={index} tile={tile} />
      ))}
    </div>
  )
}

export default TileList
